import React from 'react';
import { CustomerPage, LogoRow, LogoItem, ImgWithBlend } from './Customers.style';
import { ImgWH } from '@pages/CommonStyle/common.style';

// 1~41번 로고 import
import {
  customerLogo1,
  customerLogo2,
  customerLogo3,
  customerLogo4,
  customerLogo5,
  customerLogo6,
  customerLogo7,
  customerLogo8,
  customerLogo9,
  customerLogo10,
  customerLogo11,
  customerLogo12,
  customerLogo13,
  customerLogo14,
  customerLogo15,
  customerLogo16,
  customerLogo17,
  customerLogo18,
  customerLogo19,
  customerLogo20,
  customerLogo21,
  customerLogo22,
  customerLogo23,
  customerLogo24,
  customerLogo25,
  customerLogo26,
  customerLogo27,
  customerLogo28,
  customerLogo29,
  customerLogo30,
  customerLogo31,
  customerLogo32,
  customerLogo33,
  customerLogo34,
  customerLogo35,
  customerLogo36,
  customerLogo37,
  customerLogo38,
  customerLogo39,
  customerLogo40,
  customerLogo41,
} from '@assets/images/customers';

const Customers = () => {
  // 1~41번 로고 배열
  const logos = [
    customerLogo1,
    customerLogo2,
    customerLogo3,
    customerLogo4,
    customerLogo5,
    customerLogo6,
    customerLogo7,
    customerLogo8,
    customerLogo9,
    customerLogo10,
    customerLogo11,
    customerLogo12,
    customerLogo13,
    customerLogo14,
    customerLogo15,
    customerLogo16,
    customerLogo17,
    customerLogo18,
    customerLogo19,
    customerLogo20,
    customerLogo21,
    customerLogo22,
    customerLogo23,
    customerLogo24,
    customerLogo25,
    customerLogo26,
    customerLogo27,
    customerLogo28,
    customerLogo29,
    customerLogo30,
    customerLogo31,
    customerLogo32,
    customerLogo33,
    customerLogo34,
    customerLogo35,
    customerLogo36,
    customerLogo37,
    customerLogo38,
    customerLogo39,
    customerLogo40,
    customerLogo41,
  ];

  return (
    <CustomerPage>
      <LogoRow>
        {logos.map((logo, index) => (
          <LogoItem key={index}>
            <ImgWithBlend w="150" h="75" src={logo} alt={`logo-${index}`} />
          </LogoItem>
        ))}
        {/* 무한 반복 효과를 위해 동일한 로고 다시 렌더링 */}
        {logos.map((logo, index) => (
          <LogoItem key={`dup-${index}`}>
            <ImgWithBlend w="150" h="75" src={logo} alt={`logo-dup-${index}`} />
          </LogoItem>
        ))}
      </LogoRow>
    </CustomerPage>
  );
};

export default Customers;
